import { getSurchargeDisclosureType } from "../../features/checkout/surcharge";

type Props = {
  surchargePercentage: number;
  billingZipCode: string;
};

export function SurchargeDisclosure({ surchargePercentage, billingZipCode }: Props) {
  if (getSurchargeDisclosureType(billingZipCode) === "colorado")
    return <ColoradoSurchargeDisclosure surchargePercentage={surchargePercentage} />;

  return <DefaultSurchargeDisclosure surchargePercentage={surchargePercentage} />;
}

function DefaultSurchargeDisclosure({ surchargePercentage }: { surchargePercentage: number }) {
  return (
    <div class="payment-disclosure">
      {surchargePercentage}% surcharge will be added to cover processing fees. This fee can be
      avoided by paying with check, cash, or debit card.
    </div>
  );
}

function ColoradoSurchargeDisclosure({ surchargePercentage }: { surchargePercentage: number }) {
  return (
    <div class="payment-disclosure">
      <p>{surchargePercentage}% surcharge will be added to cover processing fees.</p>
      <strong>Colorado Surcharge Disclosure</strong>
      <p>
        To cover the cost of processing a credit or charge card transaction, and pursuant to Section
        5-2-212, Colorado Revised Statutes, a seller or lessor may impose a processing surcharge in
        an amount not to exceed 2% of the total payment made for goods or services purchased or
        leased by use of a credit or charge card. A seller or lessor shall not impose a processing
        surcharge on payments made by use of cash, a check, or a debit card or redemption of a gift
        card.
      </p>
    </div>
  );
}
